import { useEffect } from "react";
import $ from "jquery";
import MobileMenu from "./mobile-menu";
import Nuplay from "../../assets/Nuplay.svg";
import LetsTalk from "../../assets/LetsTalk.svg";

export default function Nav() {
  useEffect(() => {
    // Handle dropdown hover states
    $(".nav-link-dropdown").mouseenter(function () {
      $(this).find(".dropdown-menu").addClass("is-active");
    });

    $(".nav-link-dropdown").mouseleave(function () {
      $(this).find(".dropdown-menu").removeClass("is-active");
    });

    $(".hamburger-box").on("click", function () {
      $(this).toggleClass("is-active");
      $(".mobile-menu-drawer").toggleClass("is-active");
    });
    return () => {};
  }, []);

  return (
    <div>
      <style jsx>{`
        .dropdown-menu {
          position: absolute;
          top: 100%;
          left: 0;
          background: white;
          border-radius: 8px;
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
          padding: 16px;
          min-width: 240px;
          opacity: 0;
          visibility: hidden;
          transition: all 0.3s ease;
          z-index: 1000;
          margin-top: 12px;
        }

        .dropdown-menu::before {
          content: '';
          position: absolute;
          top: -6px;
          left: 20px;
          width: 0;
          height: 0;
          border-left: 6px solid transparent;
          border-right: 6px solid transparent;
          border-bottom: 6px solid white;
          filter: drop-shadow(0 -2px 2px rgba(0, 0, 0, 0.1));
        }

        .dropdown-menu.is-active {
          opacity: 1;
          visibility: visible;
        }

        .dropdown-header {
          font-size: 11px;
          font-weight: 600;
          color: #6B7280;
          margin-bottom: 12px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .dropdown-items {
          display: flex;
          flex-direction: column;
          gap: 6px;
        }

        .dropdown-item {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 6px 0;
          color: #111827;
          text-decoration: none;
          border-radius: 4px;
          transition: color 0.2s ease;
        }

        .dropdown-item:hover {
          color: #4F46E5;
        }

        .dropdown-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 18px;
          height: 18px;
          flex-shrink: 0;
        }

        .dropdown-icon svg {
          width: 18px;
          height: 18px;
        }

        .dropdown-item span {
          font-size: 14px;
          font-weight: 400;
          line-height: 1.2;
        }

        .nav-link-dropdown {
          position: relative;
        }

        .nav-link-copy,
        .nav-link {
          font-family: 'Manrope', sans-serif;
          font-weight: 400;
          font-style: normal;
          font-size: 10.2px;
          line-height: 15.12px;
          letter-spacing: 0%;
          text-transform: uppercase;
          vertical-align: middle;
        }
      `}</style>
      <MobileMenu />
      <div className="nurix-navbar"
        style={{zIndex: 50,boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)' ,backgroundColor: 'white'}}
      >
        <div className="nurix-nav-grid"
        >


          <div
            id="w-node-_44ca6fb5-c7a5-d95f-7d18-530180a9a185-acfc53f2"
            className="nurix-nav-col is-left"
            style={{marginLeft: '30px'}}
          >
            <a
              href="https://www.nuplay.ai/"
              aria-current="page"
              className="nurix-logo-block w-inline-block w--current"
            >
              <img
                src={Nuplay}
                loading="lazy"
                alt=""
                className="nurix-logo"
              />
            </a>
          </div>
          <div
            id="w-node-_44ca6fb5-c7a5-d95f-7d18-530180a9a188-acfc53f2"
            className="nurix-nav-col is-middle"
          >
            <a href="https://www.nuplay.ai/nuplay" className="nav-link">
             <img src={Nuplay} alt="NuPLAY" style={{ height: '18px', width: 'auto' }} />
            </a>
            
            <div className="nav-link-dropdown">
              <div className="nav-link-copy">SOLUTIONS</div>
              <img
                src="https://cdn.prod.website-files.com/66796a37e9aadbf3722c4340/6698e0f54d377f520642aa64_Chevron%20Down.svg"
                loading="lazy"
                alt=""
                className="nav-link-chevron"
              />
              <div className="dropdown-menu">
                <div className="dropdown-header">SOLUTIONS</div>
                <div className="dropdown-items">
                  <a href="https://www.nuplay.ai/sales" className="dropdown-item">
                    <div className="dropdown-icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3 3V21H21" stroke="#4F46E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M7 16L12 11L16 15L21 10" stroke="#4F46E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                    <span>Sales</span>
                  </a>
                  <a href="https://www.nuplay.ai/support" className="dropdown-item">
                    <div className="dropdown-icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3 11V19C3 19.5523 3.44772 20 4 20H20C20.5523 20 21 19.5523 21 19V11" stroke="#4F46E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M7 19V13C7 12.4477 7.44772 12 8 12H16C16.5523 12 17 12.4477 17 13V19" stroke="#4F46E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M12 2V8" stroke="#4F46E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M19 8C19 11.866 15.866 15 12 15S5 11.866 5 8C5 6.93913 5.42143 5.92172 6.17157 5.17157C6.92172 4.42143 7.93913 4 9 4H15C16.0609 4 17.0783 4.42143 17.8284 5.17157C18.5786 5.92172 19 6.93913 19 8Z" stroke="#4F46E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                    <span>Support</span>
                  </a>
                  <a href="https://www.nuplay.ai/internal-workflows" className="dropdown-item">
                    <div className="dropdown-icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="3" stroke="#4F46E5" strokeWidth="2"/>
                        <path d="M12 1V3" stroke="#4F46E5" strokeWidth="2" strokeLinecap="round"/>
                        <path d="M12 21V23" stroke="#4F46E5" strokeWidth="2" strokeLinecap="round"/>
                        <path d="M4.22 4.22L5.64 5.64" stroke="#4F46E5" strokeWidth="2" strokeLinecap="round"/>
                        <path d="M18.36 18.36L19.78 19.78" stroke="#4F46E5" strokeWidth="2" strokeLinecap="round"/>
                        <path d="M1 12H3" stroke="#4F46E5" strokeWidth="2" strokeLinecap="round"/>
                        <path d="M21 12H23" stroke="#4F46E5" strokeWidth="2" strokeLinecap="round"/>
                        <path d="M4.22 19.78L5.64 18.36" stroke="#4F46E5" strokeWidth="2" strokeLinecap="round"/>
                        <path d="M18.36 5.64L19.78 4.22" stroke="#4F46E5" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    </div>
                    <span>Document Processing & Research</span>
                  </a>
                </div>
              </div>
            </div>

            <div className="nav-link-dropdown">
              <div className="nav-link-copy">INDUSTRY</div>
              <img
                src="https://cdn.prod.website-files.com/66796a37e9aadbf3722c4340/6698e0f54d377f520642aa64_Chevron%20Down.svg"
                loading="lazy"
                alt=""
                className="nav-link-chevron"
              />
              <div className="dropdown-menu">
                <div className="dropdown-header">INDUSTRIES</div>
                <div className="dropdown-items">
                  <a href="https://www.nuplay.ai/industry/ai-agents-for-retail" className="dropdown-item">
                    <div className="dropdown-icon">
                      {/* Retail icon SVG */}
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 2L3 6V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V6L18 2H6Z" stroke="#3B6AF7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M3 6H21" stroke="#3B6AF7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                    </div>
                    <span>Retail</span>
                  </a>
                  <a href="https://www.nuplay.ai/industry/ai-agents-for-insurance" className="dropdown-item">
                    <div className="dropdown-icon">
                      {/* Insurance icon SVG */}
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C7.03 2 3 6.03 3 11C3 16.25 7.03 21 12 21C16.97 21 21 16.25 21 11C21 6.03 16.97 2 12 2ZM12 19C8.13 19 5 15.87 5 12C5 8.13 8.13 5 12 5C15.87 5 19 8.13 19 12C19 15.87 15.87 19 12 19Z" stroke="#3B6AF7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                    </div>
                    <span>Insurance</span>
                  </a>
                  <a href="https://www.nuplay.ai/industry/ai-agents-for-home-services" className="dropdown-item">
                    <div className="dropdown-icon">
                      {/* Home Services icon SVG */}
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 9.5L12 3L21 9.5V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V9.5Z" stroke="#3B6AF7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M9 21V12H15V21" stroke="#3B6AF7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                    </div>
                    <span>Home Services</span>
                  </a>
                  <a href="https://www.nuplay.ai/industry/ai-agents-for-health-and-fitness" className="dropdown-item">
                    <div className="dropdown-icon">
                      {/* Health and Fitness icon SVG */}
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2V22" stroke="#3B6AF7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M2 12H22" stroke="#3B6AF7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                    </div>
                    <span>Health and Fitness</span>
                  </a>
                  <a href="https://www.nuplay.ai/industry/ai-agents-for-education" className="dropdown-item">
                    <div className="dropdown-icon">
                      {/* Education icon SVG */}
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 19V7L12 3L20 7V19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19Z" stroke="#3B6AF7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M12 3V20" stroke="#3B6AF7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                    </div>
                    <span>Education</span>
                  </a>
                </div>
              </div>
            </div>

            <div className="nav-link-dropdown">
              <div className="nav-link-copy">RESOURCES</div>
              <img
                src="https://cdn.prod.website-files.com/66796a37e9aadbf3722c4340/6698e0f54d377f520642aa64_Chevron%20Down.svg"
                loading="lazy"
                alt=""
                className="nav-link-chevron"
              />
              <div className="dropdown-menu">
                <div className="dropdown-header">RESOURCES</div>
                <div className="dropdown-items">
                  <a href="https://www.nuplay.ai/resource/success-stories" className="dropdown-item">
                    <div className="dropdown-icon">
                      {/* Customer Stories icon SVG */}
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="7" width="18" height="14" rx="2" stroke="#3B6AF7" strokeWidth="2"/><rect x="7" y="3" width="10" height="4" rx="1" stroke="#3B6AF7" strokeWidth="2"/></svg>
                    </div>
                    <span>Customer Stories</span>
                  </a>
                  <a href="https://www.nuplay.ai/resource/ai-explained" className="dropdown-item">
                    <div className="dropdown-icon">
                      {/* AI Explained icon SVG */}
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="10" stroke="#3B6AF7" strokeWidth="2"/><polygon points="10,8 16,12 10,16" fill="#3B6AF7"/></svg>
                    </div>
                    <span>AI Explained</span>
                  </a>
                  <a href="https://www.nuplay.ai/resource/webinar" className="dropdown-item">
                    <div className="dropdown-icon">
                      {/* Webinar icon SVG */}
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="7" width="18" height="10" rx="2" stroke="#3B6AF7" strokeWidth="2"/><circle cx="12" cy="17" r="2" stroke="#3B6AF7" strokeWidth="2"/><rect x="8" y="3" width="8" height="4" rx="1" stroke="#3B6AF7" strokeWidth="2"/></svg>
                    </div>
                    <span>Webinar</span>
                  </a>
                  <a href="https://www.nuplay.ai/resource/blogs" className="dropdown-item">
                    <div className="dropdown-icon">
                      {/* Blogs icon SVG */}
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="4" width="16" height="16" rx="2" stroke="#3B6AF7" strokeWidth="2"/><line x1="8" y1="8" x2="16" y2="8" stroke="#3B6AF7" strokeWidth="2"/><line x1="8" y1="12" x2="16" y2="12" stroke="#3B6AF7" strokeWidth="2"/><line x1="8" y1="16" x2="12" y2="16" stroke="#3B6AF7" strokeWidth="2"/></svg>
                    </div>
                    <span>Blogs</span>
                  </a>
                  <a href="https://www.nuplay.ai/resource/use-cases" className="dropdown-item">
                    <div className="dropdown-icon">
                      {/* Use Cases icon SVG */}
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="7" width="18" height="14" rx="2" stroke="#3B6AF7" strokeWidth="2"/><path d="M7 3H17V7H7V3Z" stroke="#3B6AF7" strokeWidth="2"/></svg>
                    </div>
                    <span>Use Cases</span>
                  </a>
                </div>
              </div>
            </div>

            <a href="https://www.nuplay.ai/company" className="nav-link">
              COMPANY
            </a>
          </div>
          <div className="absolute right-[20px] nurix-nav-col is-right">
            <a href="https://www.nuplay.ai/contact-us">
              <img src={LetsTalk} alt="Let's Talk" style={{ height: '56px', width: 'auto' }} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}